"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Rels_1 = require("../models/Rels");
const WmsRestClient_1 = require("../WmsRestClient");
class InventoryAccessor {
    constructor(wmsRestClient) {
        if (!wmsRestClient) {
            const billboardHost = process.env.WMS_BILLBOARD_HOST;
            if (!billboardHost) {
                throw new Error('WMS_BILLBOARD_HOST must be present in the process environment');
            }
            // Not required in the environment, will be used if provided
            const s3BillboardUrl = process.env.WMS_S3_BILLBOARD_URL ?? '';
            const wmsAuthBasic = process.env.WMS_AUTH_BASIC;
            if (!wmsAuthBasic) {
                throw new Error('WMS_AUTH_BASIC must be present in the process environment');
            }
            let timeout = 2000;
            const tempTimeout = process.env.WMS_CLIENT_TIMEOUT;
            if (tempTimeout) {
                try {
                    timeout = parseInt(tempTimeout);
                }
                catch {
                    console.warn(`Invalid value for WMS_CLIENT_TIMEOUT`);
                }
            }
            wmsRestClient = new WmsRestClient_1.WmsRestClient(billboardHost, s3BillboardUrl, timeout);
            wmsRestClient.wmsHost = billboardHost;
            wmsRestClient.wmsAuthBasic = wmsAuthBasic;
        }
        this._wmsRestClient = wmsRestClient;
    }
    _wmsRestClient;
    async getPalletInfo(tplguid, palletId) {
        const tempPalletInfoURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.InventorySvc.Pallets);
        const palletsInfoURI = this._wmsRestClient.substituteValues(tempPalletInfoURI.href, {});
        const result = await this._wmsRestClient.get(`${palletsInfoURI}/${palletId}`, tplguid);
        return result;
    }
    async getAssembly(tplGuid, assemblyId, detail) {
        const tempAssemblyURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.InventorySvc.Assembly);
        const assemblyURI = this._wmsRestClient.substituteValues(tempAssemblyURI.href, { id: `${assemblyId}`, ...(detail ? { detail } : {}) });
        const assembly = await this._wmsRestClient.get(assemblyURI, tplGuid, 'application/hal+json');
        return assembly;
    }
    async getReceiver(tplGuid, receiverId, detail, itemdetail) {
        const tempReceiversURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.InventorySvc.Receivers);
        const receiverURI = this._wmsRestClient.substituteValues(tempReceiversURI.href, {
            rql: `readOnly.receiverId==${receiverId}`,
            ...(detail ? { detail } : {}),
            ...(itemdetail ? { itemdetail } : {}),
        });
        const response = await this._wmsRestClient.get(receiverURI, tplGuid, 'application/hal+json');
        let result;
        if (!response || response.totalResults != 1) {
            result = undefined;
        }
        else {
            result =
                response._embedded['http://api.3plCentral.com/rels/inventory/receiver'][0];
        }
        return result;
    }
    async getAdjustment(tplGuid, adjustmentId) {
        const tempAdjustmentURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.InventorySvc.Adjustment);
        const adjustmentURI = this._wmsRestClient.substituteValues(tempAdjustmentURI.href, { id: `${adjustmentId}` });
        const adjustment = await this._wmsRestClient.get(adjustmentURI, tplGuid, 'application/hal+json');
        return adjustment;
    }
}
exports.default = InventoryAccessor;
